import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { marked } from 'marked';

/**
 * Shows src/assets/CREDITS.md. After adding, removing or upgrading a dependency in
 * package.json, run `npm run credits` (scripts/generate-credits.mjs) to regenerate it.
 */
@Component({
    selector: 'app-credits',
    templateUrl: './credits.component.html',
    styleUrls: ['./credits.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, FlexLayoutModule]
})
export class CreditsComponent implements OnInit {
    credits: any;

    constructor(
        private readonly _location: Location,
        private readonly _http: HttpClient
    ) {}

    ngOnInit(): void {
        this._http
            .get('assets/CREDITS.md', { responseType: 'text' })
            .subscribe((creditsText) => {
                // let renderer = new marked.Renderer();
                // renderer.link = (href: string, title: string, text: string) => {
                //     return (
                //         `<a href="${href}"` +
                //         (title ? ` title="${title}"` : '') +
                //         ` target='_blank'>${text}</a>`
                //     );
                // };
                this.credits = marked(creditsText); //, { renderer });
            });
    }

    goBack() {
        this._location.back();
    }
}
